import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycWillsAndTrustsPooledIncomeTrustInNewYorkPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-wills-and-trusts/pooled-income-trust-in-new-york/']} />;
}
